import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { name: "mailingForm" }
const _hoisted_2 = { class: "row mb-2 mt-2" }
const _hoisted_3 = { class: "col-sm-12 mb-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "col-sm-3 col-form-label col-form-label-sm"
}, "Title", -1)
const _hoisted_6 = { class: "col-sm-9" }
const _hoisted_7 = { class: "col-sm-12 mb-2" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "col-sm-3 col-form-label col-form-label-sm"
}, "Type", -1)
const _hoisted_10 = { class: "col-sm-9" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "mailing" }, "mailing", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "push" }, "push", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "col-sm-12 mb-2" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "query",
  class: "col-sm-3 col-form-label col-form-label-sm"
}, "Query", -1)
const _hoisted_17 = { class: "col-sm-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
              type: "text",
              class: "form-control form-control-sm",
              id: "title",
              name: "title"
            }, null, 512), [
              [_vModelText, _ctx.form.name]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.type) = $event)),
              class: "form-control form-control-sm"
            }, _hoisted_13, 512), [
              [_vModelSelect, _ctx.form.type]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("textarea", {
              rows: "6",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.query) = $event)),
              type: "text",
              class: "form-control form-control-sm",
              id: "query",
              name: "query"
            }, "\n            ", 512), [
              [_vModelText, _ctx.form.query]
            ])
          ])
        ])
      ])
    ])
  ]))
}